import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'usage',
    exclusiveRoutePath: '/usage',
    getComponent: () => import('./Usage.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};
